import { render, staticRenderFns } from "./GroupsProductListing.vue?vue&type=template&id=01edfa16&"
import script from "./GroupsProductListing.vue?vue&type=script&lang=js&"
export * from "./GroupsProductListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports